module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_04_6NX26_1SF_H2U.c37fb1e4.jpg";